import HammerIcon from '@assets/icons/hammer.svg';
import React from 'react';
import { useSegmentActive } from '@usepepper/sprout-kit-ui';
import { useTheme } from '@/contexts/theme-context';

const HAMMER_ICON_SIZE = 16;

// sprout-kit-ui doesn't provide our preferred build mode icon, so we use a hammer icon
export const OrderEntryMobileBuildModeIcon: React.FC = () => {
  const theme = useTheme();
  const active = useSegmentActive();
  return (
    <HammerIcon
      height={HAMMER_ICON_SIZE}
      stroke={
        active ? theme.sk.color.icon.primary : theme.sk.color.icon.secondary
      }
      width={HAMMER_ICON_SIZE}
    />
  );
};
